export default (value: any) => {
  return value.slice().reverse()
}
